import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { FaBullhorn } from 'react-icons/fa';

// import ClaimDealItem from './ClaimDealItem';
import TextInput from '../../../../components/TextInput/TextInput';

const ClaimDeal = (props) => {
  const { className, phrase, onPhraseChange, errorMessage } = props;

  return (
    <div
      className={classnames('claim-offer', {
        [className]: className,
      })}
    >
      <div className="claim-offer__title">CLAIMING</div>
      <div className="claim-offer__info mb-3">Type a passphrase which will be used by users to claim deals?</div>
      <div className="d-flex justify-content-center">
        {/* <ClaimDealItem title="Phrase" Icon={FaBullhorn} checked onChange={() => {}} /> */}
        <TextInput
          className="mb-4"
          label="Phrase:"
          placeholder="Type a phrase"
          name="phrase"
          Icon={FaBullhorn}
          value={phrase}
          onChange={onPhraseChange}
          errorMessage={errorMessage}
        />
        {/* <ClaimDealItem title="Barcode" Icon={FaBarcode} checked={false} disabled />
        <ClaimDealItem title="QR Code" Icon={FaQrcode} checked={false} disabled /> */}
      </div>
    </div>
  );
};

ClaimDeal.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  phrase: PropTypes.string.isRequired,
  onPhraseChange: PropTypes.func.isRequired,
};

export default ClaimDeal;
